import { useParams } from "react-router";
import { useSelfQuery } from "../queries/user-queries";
import { useMemo } from "react";

export function useCurrentTeamMembership() {
  const { teamExternalId } = useParams();
  const { data: user } = useSelfQuery();

  const teamMembership = useMemo(() => {
    if (!user || !teamExternalId) {
      return null;
    }

    return (
      user.teamMemberships.find(
        (membership) => membership.teamExternalId === teamExternalId,
      ) ?? null
    );
  }, [user, teamExternalId]);

  if (!user || !teamExternalId) {
    return null;
  }

  return teamMembership;
}
